export default {"src":"/_next/static/media/growth-sm.colour.cea968ca.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};